import { useInfiniteQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';
import type { PageType } from '../../types/PhotoCardType';
import type { MemberType } from '../../types/ArtistType';

const DEFAULT_PAGE = 3;

//@TODO 포토카드에 필터가 들어가게 된다면 사용할 타입
// biome-ignore lint/correctness/noUnusedVariables: 필드옵션 추가하면 사용할 타입
interface PhotoCardEventsFilterProps {
  artistId: string;
  currentMember: MemberType | null;
  eventIds: number[] | null;
  category:
    | 'misc'
    | 'offline'
    | 'birthday_cafe'
    | 'ADs'
    | 'lightstick'
    | 'experience_space'
    | 'billboard_ad'
    | 'membership'
    | 'seasons'
    | 'content'
    | 'album'
    | null;
  likedEventOnly: boolean | null;
  adminMode: boolean | null;
}

interface PhotoCardEventsQueryProps {
  artistId: string;
  memberId: string;
  likedEventOnly?: boolean;
}

export default function usePhotoCardEventsQuery({
  artistId,
  memberId,
  likedEventOnly = false
}: PhotoCardEventsQueryProps) {
  async function fetchEvents({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: DEFAULT_PAGE.toString(),
      page: pageParam.toString()
    });

    if (memberId) {
      queryParams.append('member_id', memberId);
    }

    if (likedEventOnly) {
      queryParams.append('liked_event_only', 'true');
    }

    const url = `/api/v1/artists/${artistId}/events?${queryParams.toString()}`;

    try {
      const data = await queryGet(url);
      return data;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const query = useInfiniteQuery<PageType, Error, PageType>(
    ['photoCardEvents', artistId, memberId, likedEventOnly],
    fetchEvents,
    {
      enabled: !!artistId && !!memberId,
      getNextPageParam: (lastPage) => lastPage?.meta?.pagination?.nextPage
    }
  );

  // #region events
  const loadMore = () => {
    if (query.hasNextPage) {
      query.fetchNextPage();
    }
  };

  return {
    ...query,
    loadMore
  };
}
